// Auto-generated version file - DO NOT EDIT MANUALLY
// Generated on: 2026-10-24T20:30:26.750Z
// Build environment: production

export interface AppVersion {
  version: string;           // Full semantic version (e.g., "1.2.345")
  fullVersion: string;       // Full version with metadata (e.g., "1.2.345-staging+20251114052718")
  shortVersion: string;      // Version with environment (e.g., "1.2.345-staging")
  environment: string;       // Build environment (e.g., "staging" or "production")
  buildTimestamp: string;    // Build timestamp (e.g., "20251114052718")
  buildDate: string;         // Human readable build date (e.g., "2025-11-14 05:27:18 UTC")
  gitCommit: string;         // Git commit hash (e.g., "a1b2c3d")
}

export const APP_VERSION: AppVersion = {
  version: '1.0.26',
  fullVersion: '1.0.26-production+261024203026',
  shortVersion: '1.0.26-production',
  environment: 'production',
  buildTimestamp: '261024203026',
  buildDate: '2026-10-24 20:30:26 UTC',
  gitCommit: '23e746f',
};
